// src/translations/supportedLanguages.ts

import type { LanguageOption } from "@/types/types";

const supportedLanguages = [
  { code: "ar", name: "العربية" },
  { code: "fr", name: "Français" },
  { code: "pt", name: "Português" },
  { code: "es", name: "Español" },
  { code: "zh", name: "中文" },
  { code: "de", name: "Deutsch" },
  { code: "tr", name: "Türkçe" },
  { code: "it", name: "Italiano" },
  { code: "ja", name: "日本語" },
  { code: "ko", name: "한국어" },
  { code: "ru", name: "Русский" },
  { code: "nl", name: "Nederlands" },
  { code: "no", name: "Norsk" },
  { code: "sv", name: "Svenska" },
  { code: "uk", name: "Українська" },
  { code: "cs", name: "Čeština" },
  { code: "el", name: "Ελληνικά" },
  { code: "fi", name: "Suomi" },
  { code: "da", name: "Dansk" },
] as const;

export type SupportedLanguage = (typeof supportedLanguages)[number];
export type SupportedLanguageCode = SupportedLanguage["code"];
export type Language = SupportedLanguageCode | "en";

export const defaultLanguage: LanguageOption = { code: "en", name: "English" };

export { supportedLanguages };
